import { useEffect } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { atomCurrentStep, atomPaymentData, atomPisPaymentId } from 'src/storage'

export const BeforeUnloadRoot = () => {
  const pisPaymentId = useRecoilValue(atomPisPaymentId)
  const setPaymentData = useSetRecoilState(atomPaymentData)
  const setCurrentStep = useSetRecoilState(atomCurrentStep)

  useEffect(() => {
    // Detect if the page is reloaded
    sessionStorage.setItem('isReloading', 'false')

    const handleBeforeUnload = () => {
      const isReloading = sessionStorage.getItem('isReloading') === 'true'
      if (!isReloading && pisPaymentId === undefined) {
        // Reset state only if not a refresh or is pisPayment
        setPaymentData(undefined)
        setCurrentStep(3)
      }
    }

    const topWindow = window.top ?? window

    topWindow.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      topWindow.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return <></>
}
